import { Configuration, PopupRequest } from '@azure/msal-browser';

import { MICROSOFT_INTEGRATION_CLIENT_ID } from '@/common/constants';

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: MICROSOFT_INTEGRATION_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: `${window.location.origin}/msal/auth`,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Used for both OneDrive and SharePoint

// Scopes for OneDrive file picker
// OneDrive SDK v7.2 still requires *legacy‑style* delegated scopes: Files.Read + Sites.Read.All
// TODO: Remove .All scopes once v8.0 is stable
export const oneDrivePickerScopesAll = ['Files.Read.All', 'Sites.Read.All'];
export const oneDrivePickerScopesSelected = ['Files.Read.Selected', 'Sites.Selected'];
// Test narrower scopes
export const oneDrivePickerScopes = [...oneDrivePickerScopesAll, ...oneDrivePickerScopesSelected];
export const oneDrivePickerScopesStr = oneDrivePickerScopes.join(' ').trim();

// Login request config - include picker scopes to avoid consent_required errors
export const loginRequest: PopupRequest = {
  scopes: oneDrivePickerScopes,
  // select_account: Interrupts single sign-on by providing an account selection experience listing all the accounts in session or an option to choose a different account altogether
  prompt: 'select_account',
};

// Once the user has selected files, use the default RSC permission
export const defaultRequest: PopupRequest = {
  scopes: oneDrivePickerScopesSelected,
};

// Constants for Microsoft file picker
export const MICROSOFT_FILE_PICKER_PREFIX = 'MICROSOFT_FILE_PICKER_';
export const MSFT_FILE_PICKER_PENDING = `${MICROSOFT_FILE_PICKER_PREFIX}PENDING`;
export const MSFT_FILE_PICKER_SUCCESS = `${MICROSOFT_FILE_PICKER_PREFIX}SUCCESS`;
export const MSFT_FILE_PICKER_CANCEL = `${MICROSOFT_FILE_PICKER_PREFIX}CANCEL`;
export const MSFT_FILE_PICKER_ERROR = `${MICROSOFT_FILE_PICKER_PREFIX}ERROR`;
